import { createReducer, on } from '@ngrx/store';
import { promoCodeActions } from '@store/promocode/promocode.actions';
import { PromoCode } from '@api/backend';
import { ErrorResponse } from '@core/models';


export const promoCodeFeatureKey = 'promoCode';

export interface PromoCodeState  {
  code: string | null;
  promoCode: PromoCode | null;
  isPromoCodeApplied: boolean;
  error?: ErrorResponse;
  isLoading: boolean;
  isListLoading: boolean;
  list: Array<PromoCode>
  listError?: ErrorResponse
}

const initialPromoCodeState: PromoCodeState = {
  code: null,
  promoCode: null,
  isPromoCodeApplied: false,
  error: undefined,
  isLoading: false,
  isListLoading: false,
  list: [],
  listError: undefined,
};

export const promoCodeReducer = createReducer(
  initialPromoCodeState,

  on(promoCodeActions.validate, (state, { code }): PromoCodeState => ({
    ...state, code, isLoading: true, isPromoCodeApplied: false, error: undefined,
  })),
  on(promoCodeActions.validateSuccess, (state, { promoCode }): PromoCodeState => ({
    ...state, promoCode, isLoading: false, isPromoCodeApplied: false,
    error: !promoCode.is_used ? undefined : {
      error: {
        errors: [{
          error_key: 'not_found',
          error_message: 'not_found',
          error_loc: [],
        }],
      },
      message: 'string',
      status: 404,
      url: '',
    },
  })),
  on(promoCodeActions.validateFailure, (state, { error }): PromoCodeState => ({
    ...state, error, isLoading: false, isPromoCodeApplied: false,
  })),

  on(promoCodeActions.apply, (state, { code }): PromoCodeState => ({
    ...state, code, isLoading: true, isPromoCodeApplied: false,
  })),
  on(promoCodeActions.applySuccess, (state): PromoCodeState => ({
    ...state, isLoading: false, isPromoCodeApplied: true,
  })),
  on(promoCodeActions.applyFailure, (state, { error }): PromoCodeState => ({
    ...state, error, isLoading: false, isPromoCodeApplied: false,
  })),

  on(promoCodeActions.getList, (state): PromoCodeState => ({
    ...state, isListLoading: true, listError: undefined,
  })),
  on(promoCodeActions.getListSuccess, (state, { promoCodes }): PromoCodeState => ({
    ...state, isListLoading: false, list: promoCodes, listError: undefined,
  })),
  on(promoCodeActions.getListFailure, (state, { error }): PromoCodeState => ({
    ...state, error, isListLoading: false, listError: error,
  })),


  on(promoCodeActions.reset, (state): PromoCodeState => ({
    ...state,
    code: null,
    promoCode: null,
    isPromoCodeApplied: false,
    error: undefined,
    isLoading: false,
  })),
);